interface Props {
  name: string;
  size?: string | null;
  /** Pre-joined, pre-translated add-on list. */
  addonsLabel?: string | null;
  quantity: number;
  lineTotal: number;
}

// One ordered line on the order-status screens (delivered, awaiting payment,
// order received). Previously inlined three times with no wrapping rule at
// all: a long Finnish compound couldn't shrink below its min-content width, so
// it shoved the quantity/price column and spilled out of the rounded box.
// min-w-0 lets the column shrink, overflow-wrap breaks the word rather than
// the layout, and the right column never shrinks.
export function OrderLineRow({ name, size, addonsLabel, quantity, lineTotal }: Props) {
  return (
    <div
      className="flex items-start justify-between gap-3 px-4 py-2 rounded-lg"
      style={{ backgroundColor: 'rgba(255,255,255,0.1)' }}
    >
      <div className="text-left min-w-0 flex-1">
        <p className="text-white text-sm font-medium leading-snug break-words [overflow-wrap:anywhere]">
          {name}
        </p>
        {size && <p className="text-white/60 text-xs break-words">{size}</p>}
        {addonsLabel && (
          <p className="text-white/40 text-[10px] italic leading-snug break-words">{addonsLabel}</p>
        )}
      </div>
      <div className="text-right flex-shrink-0">
        <p className="text-white text-sm tabular-nums">x{quantity}</p>
        <p className="text-white/80 text-xs tabular-nums">€{lineTotal.toFixed(2)}</p>
      </div>
    </div>
  );
}
